import React, { useState } from 'react';
import { siteConfig } from '../../config/siteConfig';
import './FestivalAccordion.css';

const FestivalAccordion = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const { about } = siteConfig;

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <div className="about-festival-accordion-container">
      {about.accordion.map((festival, index) => (
        <div key={index} className="about-festival-accordion-item">
          <div 
            className="about-festival-accordion-header"
            onClick={() => toggleAccordion(index)}
          >
            <h3>{festival.title}</h3>
            <span className={`about-accordion-icon ${openAccordion === index ? 'open' : ''}`}>
              {openAccordion === index ? '−' : '+'}
            </span>
          </div>
          
          {openAccordion === index && (
            <div className="about-festival-accordion-content">
              <div className="about-festival-content-inner">
                <div className="about-festival-description">
                  <p>{festival.description}</p>
                </div>
                
                <div className="about-festival-banner">
                  <img src={festival.bannerImage.src} alt={festival.bannerImage.alt} />
                </div>
                
                <div className="about-festival-footer">
                  <a 
                    href={festival.websiteUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="about-festival-website-link"
                  >
                    {festival.website}
                  </a>
                  <div className="about-festival-social-links">
                    {festival.socialMedia.map((social, socialIndex) => (
                      <a 
                        key={socialIndex}
                        href={social.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="about-social-link"
                      >
                        <i className={social.icon}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FestivalAccordion; 